
import { Identity } from '../base/identity';

export class HorseIdentity extends Identity {

    constructor(params?: Partial<HorseIdentity>) {
        super(params);
    }
}
